<template>
     
    <!--<div class="signup">-->
      <v-flex xs12 sm12 md12 lg12 xl12 class="signup">
        <v-container>
  <div class='pattern'></div>
  <v-layout class="tiranaranja" justify-end >
    <img class="hidden-xs-only" src="elementos-pantalla-azulcielo-14.png" >
    <img class="hidden-sm-and-up" src="elementos-pantalla-azulcielo-14.png" height="150px" style="margin-top:30%">
  </v-layout>

<v-layout class="divcode" row justify-center >      
          <v-form class="formcode" v-model="valid" style=" border-radius:20px">
              <v-container>
                <v-flex xs12 md12 lg12>
                <v-card-title 
                class=" lighten-2 justify-center addcode"
                primary-title
                
              >
                Ingresa tu código Lalabum
                
               </v-card-title>
               </v-flex>
                <v-layout row wrap justify-center class="pt-3 ">
                  
                    <v-flex xs12 md12 lg12>
                      <v-text-field
                        v-model="code" 
                        :rules="[rules.required]"
                        :counter="8"
                        required
                        solo
                        flat
                        style="background:white; border-radius:8px;" class="pa-1 codetext"
                        
                      ></v-text-field>
                       

                      <br><br>
                      <v-layout justify-center>
                        <v-btn
                          large
                          
                          class="text-none loginbutton"
                          color="#4ba96c"
                          dark
                          @click="register()"
                          
                        >
                          Enviar 
                        </v-btn>
                        
          
                          </v-layout>
                        <br><br>

                      <v-layout justify-center>
                      <CodeInfo></CodeInfo>
                      </v-layout>
                      
                  </v-flex>

                    
                   
                    

                                 
                </v-layout>

               <!-- <v-layout justify-center>
                  <LoginButton></LoginButton>
                </v-layout>-->

              </v-container>
            </v-form>
        </v-layout>

<v-layout class="pl-5 mrosa" >
<img class="hidden-xs-only" src="mrosa.png">
<img class="hidden-sm-and-up" src="mrosa.png" height="150px">
</v-layout>
<!--<div class="hidden-sm-and-up"><br><br><br><br><br><br></div>
<div v-show="$vuetify.breakpoint.sm"><br><br><br><br><br></div>
<div v-show="$vuetify.breakpoint.md"><br><br><br><br><br><br><br><br><br><br><br><br><br><br></div>-->
     </v-container>
      </v-flex>
<!--</div>-->


</template>


<script>

import CodeInfo from "../components/CodeInfo.vue"

export default {
  components:{
    CodeInfo
  },
    data () {
      return {
        
        show3: false,
        valid:false,
        password: 'Contraseña',
        rules: {
          required: value => !!value || 'Required.',
          //max: v => v.length = 8 || 'Deben ser 8 caracteres',
          //emailMatch: () => ('The email and password you entered don\'t match')
        },
        code: '',
      }
      
    },
    methods:{

      register: function(){
        if(this.code==""){
          alert("Código es obligatorio")
        }else{


         if (typeof(Storage) !== 'undefined') {
         let email = localStorage.Email
         let password = localStorage.Password

        let data = {
           user: email,
           password: password,
           license: this.code,
         }
        
        this.$store.dispatch('register', data)

        .then(() =>      
              this.$router.push('/login')
        )
        .catch(function () {
           //alert("Hubo un problema");
       })
       localStorage.clear()
         }
          else {
          alert("localstoragge no funciona")
        }
        }
      },

      /*noregister: function(){
        if(this.code==""){
          alert("Llenar campos correctaente")
        }else{


        if (typeof(Storage) !== 'undefined') {
         let email = localStorage.Email
        let password = localStorage.Password

        let data = {
           user: email,
           password: password,
           license: this.code,
         }
         
       localStorage.clear()
       this.$router.push('/login')
         }
          else {
          alert("localstoragge no funciona")
        }
        }
      }*/
    }
    
}
</script>


<style>

@media (min-width: 750px){
  .addcode{
    color:white;
    font-family:Poppins!important;
    font-size:2.5vw;
    font-weight:600;
  }
  .divcode{
    margin-top:-165px;
  }
  .codetext{
    font-size: 2.5vw;
  }
}
@media (min-width: 300px) and (max-width: 750px){
  .addcode{
    color:white;
    font-family:Poppins!important;
    font-size:5.5vw;
    font-weight:600;
    text-align: center;
  }
  .divcode{
    margin-top:-100px;
  }
  .formcode{
    width: 80%;
  }
  .codetext{
    font-size: 6.8vw;
  }
}

</style>